// extracted by mini-css-extract-plugin
module.exports = {"confirmation-page-wrapper":"ConfirmationPage_confirmation-page-wrapper__1Oqy4"};